import React, { memo, useEffect, useMemo, useState } from 'react'
import MultiSelect from './Multiselect'
import DropDownSkeleton from './DropDownSkeleton'
import { LoadListDefault, useGet } from '../../../api/hooks'
import { IsListNotEmpty } from '../../../utils'

const DropDown = ({ label, depArr = [], params = [], endPoint, defaultValue, formHandler, className = "col-md-6", isMulti = true, isDisabled = false, isRequired = true, isClearable = true }) => {

  const { formValues, handleFormValues } = formHandler

  const [sOptions, setSOptions] = useState(null)
  const [firstLoad, setFirstLoad] = useState(true)

  const paramsObject = useMemo(() => {
    let dataOfObject = []
    params.forEach((param, index) => {
      dataOfObject[index] = formValues[param]?.value || ""
    })
    return dataOfObject
  }, [params, formValues])

  const { result: options, isPending } = useGet({
    ...LoadListDefault,
    endPoint: endPoint,
    depArr: depArr,
    params: paramsObject,
    defaultValue: []
  })

  const handleChange = (sOptions) => {
    handleFormValues(label, { value: sOptions, isRequired, isError: false })
    setSOptions(sOptions)
  }


  useEffect(() => {
    if (IsListNotEmpty(options)) {
      if (firstLoad && defaultValue) {
        const dffValue = defaultValue || (isMulti ? [] : null)
        const selectedOptions = isMulti ? options?.filter(option => dffValue.includes(option.value)) : options?.find(option => option.value === dffValue)
        handleChange(selectedOptions)
        setFirstLoad(false)
      }
    }

  }, [defaultValue, options])

  return (
    <>
      <DropDownSkeleton isRender={isPending} className={className} />

      <MultiSelect isRender={!isPending} label={label} sOptions={sOptions} setSOptions={handleChange} isRequired={isRequired}
        isClearable={isClearable} className={className} isMulti={isMulti} isDisabled={isDisabled} options={options} />
    </>

  )
}

export default memo(DropDown)